import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { WebApiCalls } from '../../webApiCalls/webApiCalls'
import _, { template } from 'lodash'
import { List } from 'react-content-loader'
import {
    UpdateCartCount,
    UpdateCartAmount
} from "../../redux/actions/postActions";
import { KMTracking, campaignRecord } from '../../components/Tracking/KMTracking';
import cleanURL from '../../common/cleanURL';
import { Link } from 'react-router-dom'

const MyListLoader = () => <List />
const merchantGroup: any = [
    { initial: "0", brands: [] },
    { initial: "1", brands: [] },
    { initial: "2", brands: [] },
    { initial: "3", brands: [] },
    { initial: "4", brands: [] },
    { initial: "5", brands: [] },
    { initial: "6", brands: [] },
    { initial: "7", brands: [] },
    { initial: "8", brands: [] },
    { initial: "9", brands: [] },
    { initial: "A", brands: [] },
    { initial: "B", brands: [] },
    { initial: "C", brands: [] },
    { initial: "D", brands: [] },
    { initial: "E", brands: [] },
    { initial: "F", brands: [] },
    { initial: "G", brands: [] },
    { initial: "H", brands: [] },
    { initial: "I", brands: [] },
    { initial: "J", brands: [] },
    { initial: "K", brands: [] },
    { initial: "L", brands: [] },
    { initial: "M", brands: [] },
    { initial: "N", brands: [] },
    { initial: "O", brands: [] },
    { initial: "P", brands: [] },
    { initial: "Q", brands: [] },
    { initial: "R", brands: [] },
    { initial: "S", brands: [] },
    { initial: "T", brands: [] },
    { initial: "U", brands: [] },
    { initial: "V", brands: [] },
    { initial: "W", brands: [] },
    { initial: "X", brands: [] },
    { initial: "Y", brands: [] },
    { initial: "Z", brands: [] },
]
function BrandsListing(props) {
    const [is_loading, setIsLoading] = useState(false)
    const [merchants, setMerchants] = useState<any>([])
    const [merchantGroups, setMerchantGroups] = useState<any>(merchantGroup)
    const [dataFetchingDone, setDataFetchingDone] = useState(false)
    const ForceUpdate = useState<any>()[1].bind(null, {})

    useEffect(() => {
        const data = {
            'Current Page': 'ShowAllStores',
            'Source Page': props?.location?.state?.from ? props?.location?.state?.from : ''
        }
        props.location.search && campaignRecord(props.location.search, props.location.pathname)
        tracker('pageviewed', data)
    }, [])
    const tracker = async (eventName, _kmprops) => {
        await KMTracking(eventName, _kmprops)
    }

    useEffect(() => {
        if (props?.history?.location) {
            window.scrollTo(0, 0)
        }
        getMerchants()
    }, [dataFetchingDone, merchantGroups])
    const getMerchants = async () => {
        setIsLoading(true)
        await new WebApiCalls().getAllMerchants().then((response) => {
            if (response && response.body && response.body.Records) {
                let tempList = response.body.Records.filter(item => item.DisplayName != '' && item.DisplayName != 'Delivery')
                tempList?.length > 0 && tempList?.map((item, index) => {
                    const BannerImage = item?.CustomFields
                        ? item?.CustomFields?.length > 0
                            ? item?.CustomFields?.filter((item2) =>
                                item2?.Name?.includes("BannerURL")
                            ).length > 0
                                ? item?.CustomFields?.filter((item2) =>
                                    item2?.Name?.includes("BannerURL")
                                )[0].Values[0]
                                : ""
                            : ""
                        : "";
                    // if(BannerImage == ''){
                    //     tempList.splice(index, 1)
                    // }
                    if (!item?.Media[0]?.MediaUrl) {
                        tempList.splice(index, 1)
                    }
                })

                console.log("Checking Merchant array in brands page", tempList)
                setMerchants(_.sortBy(tempList, (x)=>{
                 return  x.DisplayName.toLowerCase();
                }))
            }
        })
        groupMerchants()
    }
    const groupMerchants = () => {
        merchants?.map((item) => {
            merchantGroups?.map((item2, index2) => {
                if (item?.DisplayName?.toString().substring(0, 1) == item2.initial || item?.DisplayName?.toString().substring(0, 1) == item2.initial.toLowerCase()) {
                    merchantGroup[index2].brands = [...merchantGroup[index2].brands, item]
                }
            })
        })
        setMerchantGroups(merchantGroup)
        setDataFetchingDone(true)
        ForceUpdate()
        setIsLoading(false)
    }
    const navigateToGroup = (item: any) => {
        var scrollDiv = document?.getElementById(item)?.offsetTop;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
    }

    return (
        <div>

            <div className="viewport"></div>

            {/* /container */}
            <div className="container">

                {/* header */}
                <Header props={props} />
                {/* /header */}
                {/* mainmenu */}
                <MenuBar props={props} />
                {/* /mainmenu */}

                {/* /content */}
                <div className="content">

                    {/* breadcrumb-back */}
                    <div onClick={() => props?.history?.goBack()} className="breadcrumb-back">

                        {/* breadcrumb */}
                        <div className="breadcrumb" style={{ backgroundColor: "rgb(255,255,255,0.3)" }}>
                            <Link to="/">Home</Link>
                            <a href="">Brands List</a>
                        </div>
                        {/* /breadcrumb */}

                        <a className="backbtn">BACK</a>

                    </div>
                    {/* /breadcrumb-back */}

                    {/* brands */}
                    <div className="brands">

                        <div className="title">Shop Our Brands</div>

                        <div className="alphabets">
                            <a className="active" style={{ textDecoration: 'none' }}>0 - 9</a>
                            {merchantGroups?.map((item, index) => {

                                return (
                                    Number.isNaN(parseInt(item.initial)) &&
                                    <a key={index} onClick={() => {
                                        navigateToGroup(item?.initial)
                                    }}>{item.initial}</a>
                                )
                            })}
                        </div>

                        <div className="listing">

                            {

                                is_loading ? <MyListLoader />
                                    :
                                    merchantGroups?.map((item, index) => {
                                        if (item?.brands?.length < 1) { return }
                                        return (
                                            <section key={index} id={item.initial}>
                                                <div className="letter">{item?.initial}</div>
                                                {_.uniqBy(item?.brands, 'ID').map((item2: any, index2) => {
                                                    if (item2?.DisplayName == "FRx Delivery" || item2.DisplayName == "") return;
                                                    if (!item2.Media || !item2.Media[0] || !item2.Media[0].MediaUrl) return;
                                                    return (
                                                        <Link key={index2} to={{ pathname: `/brand/${cleanURL(item2?.DisplayName)}/${item2?.ID}`, state: { from: 'Brand Listings' } }}
                                                        >{item2.DisplayName !== '' ? item2.DisplayName : `No brands starting with ${item?.initial}`}</Link>
                                                    )
                                                })}
                                            </section>
                                        )
                                    })
                            }

                            {/* <section>
                                <div className="letter">B</div>
                                <a  >Baby Spa</a>
                                <a  >Birkenstock</a>
                                <a  >Branded Outlet</a>
                                <a  >Bedroom Affairs</a>
                                <a  >Better Vision</a>
                            </section>

                            <section>
                                <div className="letter">C</div>
                                <a  >Chalone</a>
                                <a  >Birkenstock</a>
                                <a  >Branded Outlet</a>
                                <a  >Bedroom Affairs</a>
                                <a  >Better Vision</a>
                            </section>

                            <section>
                                <div className="letter">D</div>
                                <a  >Dollars and Scent</a>
                                <a  >Dr Kong</a>
                            </section>

                            <section>
                                <div className="letter">E</div>
                                <a  >Echo of Nature</a>
                                <a  >Ecok Charcoal House</a>
                                <a  >Estetica</a>
                            </section>

                            <section>
                                <div className="letter">F</div>
                                <a  >Frank Williams</a>
                            </section>

                            <section>
                                <div className="letter">G</div>
                                <a >GK Global</a>
                                <a >Gadget Mix</a>
                            </section> */}

                        </div>

                    </div>
                    {/* /brands */}

                </div>
                {/* /content*/}


            </div>
            {/* /container */}

            {/* footer */}
            <Footer props={props} />
            {/* /footer */}

        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count } = state.UserReducer
    return { cart_count }
};
const actions = {
    UpdateCartCount,
    UpdateCartAmount
};
export default connect(mapStateToProps, actions)(BrandsListing);